// removed by extract-text-webpack-plugin
module.exports = {"downloads":"DownloadsButton-downloads","pendingBadge":"DownloadsButton-pendingBadge"};